<template>
  <div class="content">
    <div class="filter f--c">
      <el-select v-model="listParams.status" size="medium" clearable placeholder="请选择状态" style="width:130px;" @change="e => change(e, 'status')">
        <el-option label="在售" :value="1" />
        <el-option label="下架" :value="0" />
      </el-select>
      <div class="select-picker">
        <el-select v-model="dateType" size="medium" placeholder="请选择" style="width:120px;" @change="onSelectDateType">
          <el-option label="创建时间" :value="1" />
          <el-option label="更新时间" :value="2" />
        </el-select>
        <el-date-picker v-model="dateTime" size="medium" type="datetimerange" style="width:370px;padding-right:0;position: relative;top:-1px" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>
      <BatchSearch :option="searchConditionOptins" :selected="searchType" @select="handleSearchType" @search="search" @clear="searchClear" />
      <!-- <el-button size="medium" icon="el-icon-refresh-right" style="margin-left:10px" @click="handleCurrentChange(1)">刷新</el-button> -->
      <el-button size="medium" @click="editEmail" style="margin-left:10px">修改客户邮箱</el-button>
    </div>

    <el-table v-loading="loading" :data="list" height="calc(100vh - 190px)" row-key="id">
      <el-table-column label="面料信息" :min-width="220">
        <div class="table-info f--c" slot-scope="{ row }">
          <el-popover placement="right" width="280" trigger="hover">
            <el-image :src="row.kkImageUrl" fit="cover" />
            <el-image slot="reference" :src="row.kkImageUrl" fit="cover" class="img" />
          </el-popover>
          <div class="info-text">
            <div v-if="row.isEdit" class="f--c">
              <el-input v-model="row.enName" size="small" placeholder="请输入标题"></el-input>
              <el-tooltip class="item" effect="dark" content="保存" placement="top">
                <i class="el-icon-check" @click="handleEdit(row, 'enName')"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="取消" placement="top">
                <i class="el-icon-close" @click="handleClose(row, 'isEdit')"></i>
              </el-tooltip>
            </div>
            <div v-else class="f--c">
              <el-tooltip class="item" effect="dark" :content="row.enName" placement="top-start">
                <div class="ellipsis">标题: {{ row.enName || '-' }}</div>
              </el-tooltip>
              <i class="el-icon-edit edit" @click="showEdit(row, 'isEdit')"></i>
            </div>
            <div>原标题: {{ row.name }}</div>
            <div>克重：{{ row.weight }}{{ row.weightUnit }}</div>
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="status" label="面料分类" :width="180">
        <div class="category" slot-scope="{ row }">
          <div v-if="row.editCategory" class="f--c">
            <el-cascader
              v-model="row.categoryIds"
              :options="options"
              :props="{ expandTrigger: 'hover' }"
              size="medium"
              @change="e => changeCascader(e, row)">
              <template slot-scope="{ data }">
                <span>{{ data.label }}</span>
                <span> ({{ data.en }}) </span>
              </template>
            </el-cascader>
            <el-tooltip class="icon" effect="dark" content="取消" placement="bottom">
              <i class="el-icon-close" @click="handleClose(row, 'editCategory')"></i>
            </el-tooltip>
          </div>
          <div v-else class="f--c">
            <el-tooltip class="item" effect="dark" :content="row.fullCategoryNameCn" placement="top-start">
              <div class="ellipsis">{{ row.fullCategoryNameCn || '-' }}</div>
            </el-tooltip>
            <i class="el-icon-edit edit" @click="showEdit(row, 'editCategory')"></i>
          </div>
        </div>
      </el-table-column>
      <el-table-column prop="status" label="状态" :width="140">
        <template slot-scope="{ row }">
          <el-select v-model="row.status" size="medium" placeholder="请选择" style="width:100px;" @change="handleEdit(row, 'status')">
            <el-option label="在售" :value="1" />
            <el-option label="下架" :value="0" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="shareUrl" label="访问链接" :min-width="230"></el-table-column>
      <el-table-column label="客户邮箱" :width="220">
        <template slot-scope="{ row }">
          <div v-if="row.kkCustomerEmails.length > 2">
            <el-tooltip class="item" effect="dark" content="Top Center 提示文字" placement="top">
              <div slot="content">
                <div v-for="t in row.kkCustomerEmails" :key="t.userId">{{ t.email }}</div>
              </div>
              <div>
                <div class="ellipsis">{{ row.kkCustomerEmails && row.kkCustomerEmails[0].email }}</div>
                <div class="ellipsis">{{ row.kkCustomerEmails && row.kkCustomerEmails[1].email }}...</div>
              </div>
            </el-tooltip>
          </div>
          <div v-else>
            <div v-if="row.kkCustomerEmails.length > 0">{{ row.kkCustomerEmails[0].email }}</div>
            <div v-if="row.kkCustomerEmails.length > 1">{{ row.kkCustomerEmails[1].email }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="时间信息" :width="220">
        <template slot-scope="{ row }">
          <div>更新时间:{{ row.modifyDate | dateFormat}}</div>
          <div>创建时间:{{ row.createDate | dateFormat}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="modifier" label="操作人" :width="130"></el-table-column>
    </el-table>

    <div class="f-b-c bg-white" style="padding: 12px">
      <div></div>
      <el-pagination background :current-page="listParams.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <EditEmail ref="editEmail" :kkCustomerEmails="list.length ? list[0].kkCustomerEmails: []" @editEmailSuccess="handleCurrentChange(1)" />
  </div>
</template>

<script>
import BatchSearch from '@/components/BatchSearch.vue'
import API from '@/api'
import { nonChinese } from '@/utils/validate'
import EditEmail from './components/editEmail.vue'

export default {
  // name: 'supply_fabricLibrary',
  components: {
    BatchSearch,
    EditEmail
  },
  data() {
    return {
      value: [2, 3],
      loading: false,
      typeList: [],
      list: [],
      listParams: {
        pageSize: 20,
        pageNumber: 1,
        status: undefined,
        createDateStart: undefined,
        createDateEnd: undefined,
        modifyDateStart: undefined,
        modifyDateEnd: undefined,
        names: undefined,
        enNames: undefined,
      },
      dateType: 1,
      dateTime: undefined,
      searchType: 1,
      total: 0,
      selection: [], // 选中的元素对象
      options:[],

      // 根据条件类型搜索下拉选项
      searchConditionOptins: [
        { label: '原标题', value: 1 },
        { label: '标题', value: 2 }
      ]
    }
  },
  created() {
    this.getCategoriesTree()
    this.getList()
  },
  mounted() {
  },
  methods: {
    getCategoriesTree() {
      API.getCategoriesTree().then(res => {
        // this.categoriesTree = res.data.list
        this.options = res.data.list.map(item => {
          return {
            label: item.languageList[1].name,
            en: item.languageList[0].name,
            value: item.id,
            children: item.children.length ? item.children.map(t => ({ label: t.languageList[1].name, en: t.languageList[0].name, value: t.id })) : undefined
          }
        })
      })
    },
    // 获取列表
    getList() {
      API.get3dFabrics(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.list = res.data.list.map(t => ({ ...t, originalEnName: t.enName, kkImageUrl: t.kkImageUrl+'?x-oss-process=image/resize,w_260,m_lfit/format,webp' }))
        this.total = res.data.total
      })
    },

    // 切换
    change(e, type) {
      let value;
      if (e || e === 0) {
        value = e
      } else {
        value = undefined
      }
      this.listParams[type] = value
      this.handleCurrentChange(1)
    },

    /**
     * 选择日期筛选类型
     *
     * @param {Number} value 当前选中的类型
     */
    onSelectDateType(value) {
      if (this.dateTime) {
        // // 付款时间
        if (value === 1) {
          this.listParams.createDateStart = this.dateTime[0]
          this.listParams.createDateEnd = this.dateTime[1]
          this.listParams.modifyDateStart = undefined
          this.listParams.modifyDateEnd = undefined
        }
        // 创建时间
        if (value === 2) {
          this.listParams.modifyDateStart = this.dateTime[0]
          this.listParams.modifyDateEnd = this.dateTime[1]
          this.listParams.createDateStart = undefined
          this.listParams.createDateEnd = undefined
        }
        this.handleCurrentChange(1)
      }
    },
    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        // 创建时间
        if (this.dateType === 1) {
          this.listParams.createDateStart = date[0]
          this.listParams.createDateEnd = date[1]
          this.listParams.modifyDateStart = undefined
          this.listParams.modifyDateEnd = undefined
        }
        // 更新时间
        if (this.dateType === 2) {
          this.listParams.modifyDateStart = date[0]
          this.listParams.modifyDateEnd = date[1]
          this.listParams.createDateStart = undefined
          this.listParams.createDateEnd = undefined
        }
      } else {
        this.listParams.createDateStart = undefined
        this.listParams.createDateEnd = undefined
        this.listParams.modifyDateStart = undefined
        this.listParams.modifyDateEnd = undefined
      }
      this.handleCurrentChange(1)
    },

    /**
     * 选择搜索类型的回调
     *
     * @param {String} value 当前选中的值
     */
    handleSearchType(value, input) {
      this.searchType = value
      if (input) this.search(input)
    },

    /**
     * 搜索按钮触发的回调
     *
     * @param {String} value
     */
    search(value) {
      // 版型编号
      if (this.searchType === 1) {
        this.listParams.names = value ? value.split(',').map((item) => item.trim()) : []
        this.listParams.enNames = undefined
      }
      // 商品名称
      if (this.searchType === 2) {
        this.listParams.enNames = value ? value.split(',').map((item) => item.trim()) : []
        this.listParams.names = undefined
      }
      this.handleCurrentChange(1)
    },

    /**
     * 批量搜索框的清除事件的回调
     */
    searchClear() {
      this.listParams.names = undefined
      this.listParams.enNames = undefined
      this.handleCurrentChange(1)
    },

    handleCurrentChange(page) {
      this.listParams.pageNumber = page || 1
      this.getList()
    },
    // 每页显示条数发生改变时的回调
    handleSizeChange(size) {
      this.listParams.pageSize = size
      this.getList()
    },

    // 显示编辑
    showEdit(row, type) {
      this.$set(row, type, true)
    },
    handleClose(row, type) {
      if (type === 'isEdit') {
        this.$set(row, 'enName', row.originalEnName)
      }
      this.$set(row, type, false)
    },

    handleEdit(row, type) {
      if (type === 'enName') {
        if (!row.enName) {
          this.$set(row, 'enName', row.originalEnName)
          this.$message.warning('标题不能为空')
          return
        } else if (!nonChinese(row.enName)) {
          this.$message.warning('请输入正确的英文标题')
          return
        }
      }
      if (type === 'status') {
        if (row.status && (!row.enName || !row.categoryId)) {
          this.$set(row, 'status', 0)
          this.$message.warning('面料分类、标题未填写时不能改成在售')
          return
        }
      }
      let enName = row.enName.trim()
      let param = {
        id: row.id,
        status: row.status,
        enName: enName.replace(/\s+/g, ' '),
        categoryId: row.categoryId
      }
      this.putProduct3dFabric(param)
    },
    // 只能输入英文和数字
    handleInput(e, row) {
      this.$set(row, 'categoryName', e.replace(/[^a-zA-Z0-9 ]+/g, '').trim())
    },
    changeCascader(e, row) {
      let param = {
        id: row.id,
        status: row.status,
        enName: row.enName,
        categoryId: e[e.length-1]
      }
      this.putProduct3dFabric(param)
    },

    putProduct3dFabric(param) {
      API.putProduct3dFabric(param).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.$message.success('修改成功')
        this.getList()
      })
    },
    editEmail() {
      this.$refs.editEmail.show(this.list.length > 0 ? this.list[0].kkCustomerEmails : [])
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  background: white;
  min-width: 1200px;
  .filter {
    padding: 12px;
    >div {
      margin-right: 10px;
    }
    .select-picker {
      white-space: nowrap;
    }
  }

  .table-info {
    width: auto;
    padding-top: 2px;
    .img {
      width: 52px;
      height: 52px;
      flex-shrink: 0;
      margin-right: 6px;
    }
    .info-text {
      width: 84%;
      margin-top: -4px;
      .edit {
        margin-left: 10px;
        color: #99c41c;
        cursor: pointer;
      }
      .el-icon-check, .el-icon-close {
        margin-left: 10px;
        font-size: 20px;
        cursor: pointer;
      }
      .el-icon-check {
        color: #99c41c;
      }
    }
  }
  .category {
    .edit {
      margin-left: 10px;
      color: #99c41c;
      cursor: pointer;
    }
    .icon {
      font-size: 18px;
      cursor: pointer;
      margin-left: 6px;
    }
    .el-icon-check {
      color: #99c41c;
    }
  }
  /deep/ .el-dropdown [disabled] {
    color: #fff
  }
}
</style>